import React from "react";
import HomePageNavCard from "../components/HomePageNavCard";
import { Col, Skeleton } from "antd";
import { useGetAllTabsUserHasAccessToQuery, useGetUserTypeQuery } from "../redux/api/user";
import { useEffect, useState } from "react";

const HomePageCardsContainer = () => {
  const allowedTabsQuery = useGetAllTabsUserHasAccessToQuery();
  const userTypeQuery = useGetUserTypeQuery();

  const [allowedTabs, setAllowedTabs] = useState([]);

  useEffect(() => {
    if (allowedTabsQuery.data) {
      setAllowedTabs(allowedTabsQuery.data);
    } else {
      setAllowedTabs([]);
    }
  }, [allowedTabsQuery.data]);

  console.log("allowedTabs", allowedTabs);

  if (!allowedTabs || allowedTabs.length <= 0 || !userTypeQuery.data || userTypeQuery.isFetching) {
    return (
      <Skeleton
        title={false}
        paragraph={{
          rows: 10,
          style: {
            marginLeft: "10%",
            marginTop: "5%",
          },
        }}
        active
      />
    );
  }
  return (
    <div
      style={{
        width: "100%",
        marginTop: "64px",
        padding: "0 50px",
        paddingBottom: "60px",
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        justifyContent: "left",
        alignItems: "center",
        gap: "2vw",
        // fade in
        animation: "fadeIn 2s",
        zIndex: "10",
      }}
    >
      <Col key="performance">
        <HomePageNavCard
          redirectUrl="/performance/overview"
          isDisabled={!allowedTabs.includes("performance")}
          description="Your one stop shop to see what is working (and what isn't). Brings together incrementality from COmpass to platform data granularity."
        />
      </Col>
      <Col key="seo">
        <HomePageNavCard
          redirectUrl="/seo/ai-health"
          title="SEO"
          description="Organic visibility, health, AI monitoring and site performance insights in one place."
          isDisabled={!allowedTabs.includes("ai_health")}
        />
      </Col>
      <Col key="navigator">
        <HomePageNavCard
          redirectUrl="/navigator"
          title="Navigator"
          isDisabled={!allowedTabs.includes("navigator")}
          description="Where data becomes actions. Turning reports and model outputs into strategies and optimisations."
        />
      </Col>
      <Col key="influencer">
        <HomePageNavCard
          redirectUrl="/influencer/content"
          title="Influencer"
          isDisabled={!allowedTabs.includes("influencer")}
          description="A view into your world of UGC and influencer content. Transforming likes into revenue."
        />
      </Col>
      {(userTypeQuery.data === "Admin" || userTypeQuery.data === "Internal") && (
        <Col key="admin">
          <HomePageNavCard
            redirectUrl="/bulk-uploader"
            title="Bulk Uploader"
            description="Streamline your ad creation workflow with our powerful bulk upload tool. Effortlessly manage and deploy multiple Facebook and Instagram ads simultaneously, saving you valuable time and resources."
          />
        </Col>
      )}
      <Col key="compass_portal">
        <HomePageNavCard
          redirectUrl="/compass-portal"
          title="Compass Portal"
          description="Manage your Compass projects from data collection through to delivery. Track progress, upload data, and collaborate across stages."
          isDisabled={!allowedTabs.includes("compass_portal")}
        />
      </Col>
      <Col key="legacy">
        <HomePageNavCard
          redirectUrl="/executive-summary"
          title="Legacy"
          description="We make things happen. But sometimes the data from the past is still valuable."
          isDisabled={!allowedTabs.includes("legacy")}
        />
      </Col>
    </div>
  );
};

export default HomePageCardsContainer;
